module.exports = __webpack_public_path__ + "img/business-pulse.5fdc5681.jpg";